var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62651 5.33391C9.49984 5.33391 9.37318 5.28724 9.27318 5.18724L7.91984 3.83391L6.56651 5.18724C6.37318 5.38057 6.05318 5.38057 5.85984 5.18724C5.66651 4.99391 5.66651 4.67391 5.85984 4.48057L7.56651 2.77391C7.75984 2.58057 8.07984 2.58057 8.27318 2.77391L9.97984 4.48057C10.1732 4.67391 10.1732 4.99391 9.97984 5.18724C9.87984 5.28724 9.75318 5.33391 9.62651 5.33391Z",
    fill: "#605BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91992 10.4519C7.64659 10.4519 7.41992 10.2252 7.41992 9.95188V3.17188C7.41992 2.89854 7.64659 2.67188 7.91992 2.67188C8.19326 2.67188 8.41992 2.89854 8.41992 3.17188V9.95188C8.41992 10.2319 8.19326 10.4519 7.91992 10.4519Z",
    fill: "#605BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 14.3333C4.56699 14.3333 2.16699 11.9333 2.16699 8.5C2.16699 8.22667 2.39366 8 2.66699 8C2.94033 8 3.16699 8.22667 3.16699 8.5C3.16699 11.3467 5.15366 13.3333 8.00033 13.3333C10.847 13.3333 12.8337 11.3467 12.8337 8.5C12.8337 8.22667 13.0603 8 13.3337 8C13.607 8 13.8337 8.22667 13.8337 8.5C13.8337 11.9333 11.4337 14.3333 8.00033 14.3333Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.b7d5c56b0879b082642c2cd381abb3ef.svg";
export { ForwardRef as ReactComponent };